import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const documentType = {
  path: '/documentTypes',
  component: Layout,
  name: 'documentTypes',
  redirect: '/documentTypes/index',
  children: [
    {
      path: '/documentTypes/index',
      component: () => import('@/views/documentType/index'),
      name: 'documentTypes.index',
      meta: { title: i18n.t(`message.type_documents`)}
    },
  ]
}

export default documentType
